var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTickLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.905,
    height: 104.469,
    viewBox: "0 0 101.905 104.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15625",
    "data-name": "Group 15625",
    transform: "translate(-608 -295.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_94_20",
    "data-name": "Component 94 \\u2013 20",
    transform: "translate(608 295.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6288",
    "data-name": "Group 6288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6271",
    "data-name": "Group 6271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8068",
    "data-name": "Path 8068",
    d: "M3187.963,3121.481s.088-7.14,7.14-7.14c0,0-7.14-.088-7.14-7.14,0,0-.088,7.14-7.14,7.14C3180.823,3114.341,3187.963,3114.429,3187.963,3121.481Z",
    transform: "translate(-3093.198 -3053.671)",
    fill: "#e1e9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8068-2",
    "data-name": "Path 8068",
    d: "M3185.731,3117.017s.061-4.908,4.908-4.908c0,0-4.908-.061-4.908-4.908,0,0-.061,4.908-4.908,4.908C3180.823,3112.109,3185.731,3112.169,3185.731,3117.017Z",
    transform: "translate(-3175.588 -3025.199)",
    fill: "#e1e9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M2877.363,2924.254s-.088-7.14-7.14-7.14c0,0,7.14-.088,7.14-7.14,0,0,.088,7.14,7.141,7.14C2884.5,2917.115,2877.363,2917.2,2877.363,2924.254Z",
    transform: "translate(-2869.453 -2890.322)",
    fill: "#e1e9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M2972.925,3227.793s-.078-6.325-6.325-6.325c0,0,6.325-.078,6.325-6.325,0,0,.078,6.325,6.326,6.325C2979.25,3221.468,2972.925,3221.546,2972.925,3227.793Z",
    transform: "translate(-2913.215 -3123.324)",
    fill: "#b0d0ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M2882.768,3148.98s-.044-3.57-3.57-3.57c0,0,3.57-.044,3.57-3.57,0,0,.044,3.57,3.57,3.57C2886.338,3145.41,2882.768,3145.454,2882.768,3148.98Z",
    transform: "translate(-2879.198 -3091.88)",
    fill: "#b0d0ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156-2",
    "data-name": "Path 8156",
    d: "M2882.768,3148.98s-.044-3.57-3.57-3.57c0,0,3.57-.044,3.57-3.57,0,0,.044,3.57,3.57,3.57C2886.338,3145.41,2882.768,3145.454,2882.768,3148.98Z",
    transform: "translate(-2800.088 -3129.327)",
    fill: "#b0d0ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M2948.939,2857.235s-.057-4.639-4.639-4.639c0,0,4.639-.057,4.639-4.639,0,0,.057,4.639,4.639,4.639C2953.578,2852.6,2948.939,2852.653,2948.939,2857.235Z",
    transform: "translate(-2918.378 -2847.957)",
    fill: "#b0d0ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8071",
    "data-name": "Path 8071",
    d: "M3174.124,3170.524a3.13,3.13,0,1,0,0-6.259,3.13,3.13,0,0,0,0,6.259Z",
    transform: "translate(-3088.314 -3086.15)",
    fill: "#b0d0ee"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_14284",
    "data-name": "Path 14284",
    d: "M32.5,0A32.5,32.5,0,1,1,0,32.5,32.5,32.5,0,0,1,32.5,0Z",
    transform: "translate(16 17.847)",
    fill: "#33c037"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14283",
    "data-name": "Path 14283",
    d: "M-3037.913,3421.135l9.782,9.782,22.507-22.507",
    transform: "translate(3677.912 -3074.288)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickLogo);
export default __webpack_public_path__ + "static/media/success-tick-logo.3c4f683ef8db655bfafea7cfe7188ef6.svg";
export { ForwardRef as ReactComponent };